import React from 'react';
import {
  Grid,
  FormControlLabel,
  Switch,
  Divider,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Chip,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { ParametroNotificacoes } from '../configuracoes/types';
import { NotificationSettings } from '../../services/notificationConfigService';
import { configSectionAccordionSx, configSectionAccordionSummarySx } from '../../styles/theme';

interface NotificacoesPushProps {
  parametros: ParametroNotificacoes;
  saving: boolean;
  onNotificationChange: (field: keyof NotificationSettings, value: boolean) => Promise<void>;
  onChange: (field: keyof ParametroNotificacoes, value: any) => void;
}

const NotificacoesPush: React.FC<NotificacoesPushProps> = ({
  parametros,
  saving,
  onNotificationChange,
  onChange,
}) => {
  const theme = useTheme();

  return (
    <Accordion disableGutters elevation={0} sx={configSectionAccordionSx(theme)}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={configSectionAccordionSummarySx(theme)}>
        <Box display="flex" alignItems="center">
          <NotificationsIcon sx={{ mr: 1, color: 'warning.main' }} />
          <Typography variant="h6">Notificações do Sistema</Typography>
          <Chip 
            label={parametros.notificacoes_push ? 'Ativo' : 'Inativo'}
            color={parametros.notificacoes_push ? 'success' : 'default'}
            size="small"
            sx={{ ml: 2 }}
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={parametros.notificacoes_push}
                  onChange={(e) => onNotificationChange('notificacoes_push', e.target.checked)}
                  color="warning"
                  disabled={saving}
                />
              }
              label="Habilitar notificações do sistema"
            />
          </Grid>

          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Typography variant="subtitle2" gutterBottom>
              Eventos de Notificação (Para Usuários do Sistema)
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={parametros.push_novo_cliente}
                  onChange={(e) => onChange('push_novo_cliente', e.target.checked)}
                  disabled={!parametros.notificacoes_push}
                />
              }
              label="Novo cliente cadastrado"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={parametros.push_novo_contrato}
                  onChange={(e) => onChange('push_novo_contrato', e.target.checked)}
                  disabled={!parametros.notificacoes_push}
                />
              }
              label="Novo contrato criado"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={parametros.push_pagamento_recebido}
                  onChange={(e) => onChange('push_pagamento_recebido', e.target.checked)}
                  disabled={!parametros.notificacoes_push}
                />
              }
              label="Pagamento recebido"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={parametros.push_chamado_criado}
                  onChange={(e) => onChange('push_chamado_criado', e.target.checked)}
                  disabled={!parametros.notificacoes_push}
                />
              }
              label="Chamado criado"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={parametros.push_meta_vendas}
                  onChange={(e) => onChange('push_meta_vendas', e.target.checked)}
                  disabled={!parametros.notificacoes_push}
                />
              }
              label="Meta de vendas atingida"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default NotificacoesPush; 